import request from '@/utils/request'

export function getDelyNoList(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/getDelyNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getEpms5010DelyList(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/getEpms5010DelyList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getEpms5010PoList(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/getEpms5010PoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5010ModDelivery(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/epms5010ModDelivery`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5010DelDelivery(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/epms5010DelDelivery`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5010InsDelivery(param) {
  let data = param
  return request({
    url: `/delivery/epms5010/epms5010InsDelivery`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}